import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { TypedCanActivateFn } from '@/common/models';
import { AuthService } from '@/pages/auth/services/auth.service';

/**
 * Guard para rutas exclusivas de usuarios NO autenticados (login, register, recover-password).
 * Si el usuario ya está logueado, redirige a su página principal sin mostrar el componente.
 * markNavigationResolved() es invocado automáticamente por AppInitializerService al
 * recibir el evento NavigationEnd del Router, después de completar todos los redirects.
 */
export const GuestOnlyGuard: TypedCanActivateFn<boolean | UrlTree> = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLogged()) {
    return router.createUrlTree(authService.getDefaultRoute());
  }

  return true;
};
